import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/fw";

export async function getCurrentGW(leagueID) {
  const leagueDoc = await getDoc(doc(db, "leagues", leagueID));
  if (!leagueDoc.exists()) throw new Error("League not found");
  return leagueDoc.data().currentGW; // e.g. "GW1"
}